module.exports = __webpack_public_path__ + "images/checkbox/checkbox_empty.png";